module.exports = __webpack_public_path__ + "static/media/hongdanshan_web.294d6dbd.png";